import _ from "lodash";

import {
  DeleteOutlineOutlinedIcon,
  ForwardToInboxOutlinedIcon,
  MoreVertIcon,
  SupervisorAccountOutlinedIcon,
} from "icons";
import theme from "theme";
import { colors } from "theme/palette";

import Box from "components/Box";
import ButtonDropdown from "components/ButtonDropdown";
import { MenuItem } from "components/Menu";
import Stack from "components/Stack";
import Text from "components/Text";
import Tooltip from "components/Tooltip";

const MemoESignatureEmailAssigneeBox = ({
  email,
  onReplace,
  onDelete,
  disableDelete = false,
}: {
  email: string;
  onReplace?: () => void;
  onDelete?: () => void;
  disableDelete?: boolean;
}) => (
  <Stack
    sx={{ backgroundColor: colors.gray10, borderRadius: "8px" }}
    gap={0.5}
    padding={1.5}
    direction="row"
    justifyContent="space-between"
  >
    <Stack>
      <Stack justifyContent="space-between" direction="row">
        <Stack direction="row" gap={1} alignItems="center">
          <ForwardToInboxOutlinedIcon sx={{ width: "24px", heigth: "24px" }} />
          <Tooltip title={email}>
            <Box
              height="22px"
              sx={{
                border: "1px solid",
                borderColor: colors.blue80,
                borderRadius: "16px",
                padding: theme.spacing(0.1, 1.5),
                maxWidth: "450px",
              }}
            >
              <Text
                variant="text4"
                color={colors.gray80}
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
              >
                {email}
              </Text>
            </Box>
          </Tooltip>
        </Stack>
      </Stack>
    </Stack>
    {!_.isNil(onReplace) && !_.isNil(onDelete) && (
      <Stack alignSelf="flex-start">
        <ButtonDropdown
          icon={<MoreVertIcon />}
          label=""
          variant="text"
          size="small"
          width="auto"
          sx={{
            padding: theme.spacing(0.5, 0.75),
          }}
        >
          <MenuItem onClick={onReplace}>
            <Stack direction="row" alignItems="center" gap={1} padding={1}>
              <SupervisorAccountOutlinedIcon sx={{ color: colors.blue80 }} />
              <Text variant="text2">Replace contact</Text>
            </Stack>
          </MenuItem>
          <Tooltip
            title={
              disableDelete
                ? "You cannot remove an assignee from a different level."
                : undefined
            }
          >
            <span>
              <MenuItem onClick={onDelete} disabled={disableDelete}>
                <Stack direction="row" alignItems="center" gap={1} padding={1}>
                  <DeleteOutlineOutlinedIcon sx={{ color: colors.blue80 }} />
                  <Text variant="text2">Remove</Text>
                </Stack>
              </MenuItem>
            </span>
          </Tooltip>
        </ButtonDropdown>
      </Stack>
    )}
  </Stack>
);

export default MemoESignatureEmailAssigneeBox;
